import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ session, children, allowed = true }) => {
    if (session === "checking") {
        return null;
    }
    if (session !== "authenticated") {
        return <Navigate to="/login" replace />;
    }
    if (!allowed) {
        return <main><p role="alert">You do not have access to this page.</p></main>;
    }
    return children;
};

export default ProtectedRoute;
